import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'SolarByState',
})(
  (
    { brandColors, spacing, type, fontWeights, breakpoints, typography },
    props
  ) => ({
    solarByStateColumnItem: {
      paddingTop: typography.pxToRem(8),
      paddingBottom: typography.pxToRem(8),
      '& a': {
        ...type['14_medium'],
        whiteSpace: 'nowrap',
      },
    },
    linkColor: {
      color: darkOrLightStyle(props)(
        brandColors.tintsChargeBlue60,
        brandColors.mediumBlue
      ),
      '&:hover': {
        color: darkOrLightStyle(props)(
          brandColors.white,
          brandColors.primaryMain
        ),
      },
    },
    expandIcon: {
      marginRight: typography.pxToRem(4),
    },
    accordionRoot: {
      border: 'none',
      backgroundColor: 'transparent',
      '&.MuiPaper-root': {
        '&:before': {
          display: 'none',
        },
        backgroundColor: 'transparent',
        boxShadow: 'none',
        width: '100%',
        [breakpoints.up('sm')]: {
          width: 'fit-content',
        },
      },
      '&.Mui-expanded': {
        margin: 0,
      },
      '&.MuiAccordion-root.Mui-expanded': {
        margin: 0,
      },
    },
    accordionSummaryRoot: {
      '&.MuiAccordionSummary-root': {
        minHeight: 'auto',
        padding: spacing(-1),
        ...type['14_medium'],
        textDecoration: 'underline',
        color: darkOrLightStyle(props)(
          brandColors.tintsChargeBlue60,
          brandColors.mediumBlue
        ),
        '&:hover': {
          color: darkOrLightStyle(props)(
            brandColors.white,
            brandColors.primaryMain
          ),
        },
      },
    },
    accordionSummaryRootExpanded: {
      '&.MuiAccordionSummary-root': {
        textDecoration: 'none',
        fontWeight: fontWeights.semibold,
        '&.Mui-expanded': {
          minHeight: 'auto',
          margin: 0,
        },
      },
    },
    accordionSummaryContent: {
      display: 'flex',
      alignItems: 'center',
      '&.MuiAccordionSummary-content': {
        margin: 0,
        '&.Mui-expanded': {
          margin: 0,
        },
      },
    },
    accordionDetailsRoot: {
      '&.MuiAccordionDetails-root': {
        padding: 0,
        paddingRight: spacing(0),
        paddingBottom: spacing(-1),
        borderTopWidth: typography.pxToRem(1),
        borderTopStyle: 'solid',
        borderTopColor: darkOrLightStyle(props)(
          'rgba(255, 255, 255, 0.30)',
          'rgba(0, 0, 0, 0.2)'
        ),
        borderBottomWidth: typography.pxToRem(1),
        borderBottomStyle: 'solid',
        borderBottomColor: darkOrLightStyle(props)(
          'rgba(255, 255, 255, 0.30)',
          'rgba(0, 0, 0, 0.2)'
        ),
      },
    },
    solarByStateColumn: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: spacing(2),
      marginRight: spacing(2),
    },
  })
);

export default useStyles;
